import { CreateEventFormAnswersForm } from "@ac-expo/api";
import { EventFormQuestion } from "@ac-expo/api-types";
import { Control } from "react-hook-form";
import { Checkbox } from "../Checkbox";
import { FormField, FormItem, FormLabel, FormMessage } from "../form/Form";
import { Label } from "../Label";

interface EventFormMultipleChoiceProps {
  question: EventFormQuestion;
  control?: Control<CreateEventFormAnswersForm>;
  index?: number;
  isReadOnly?: boolean;
}

export default function EventFormMultipleChoice({
  question,
  control,
  index,
  isReadOnly = false,
}: EventFormMultipleChoiceProps) {
  if (isReadOnly) {
    return (
      <div className="space-y-[6px]">
        <Label className="text-sm text-gray-600">
          {question.theme} : {question.question}
        </Label>
        <div className="grid grid-cols-3 gap-2 rounded-xl bg-gray-50 p-4">
          {question.options.map((option) => (
            <div key={option.label} className="flex items-center gap-2">
              <Checkbox className="data-[state=checked]:border-primary-blue data-[state=checked]:bg-primary-blue flex size-5 items-center justify-center rounded-[6px] border-gray-300 bg-white text-white" />
              <Label className="min-w-0 break-words text-sm font-bold text-gray-500">
                {option.label}
              </Label>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!control || index === undefined) {
    throw new Error(
      "control and index are required when not in read-only mode"
    );
  }

  return (
    <FormField
      key={question.id}
      control={control}
      name={`answers.${index}.answerList`}
      render={({ field, fieldState }) => (
        <FormItem>
          <div className="space-y-[6px]">
            <FormLabel className="text-sm text-gray-600">
              {question.theme} : {question.question}
            </FormLabel>
            <div className="grid grid-cols-3 gap-2 rounded-xl bg-gray-50 p-4">
              {question.options.map((option) => {
                const isChecked =
                  (field.value as string[])?.includes(option.label) || false;

                return (
                  <div key={option.label} className="flex items-center gap-2">
                    <Checkbox
                      checked={isChecked}
                      onCheckedChange={(checked) => {
                        const currentValues = (field.value as string[]) || [];
                        if (checked) {
                          field.onChange([...currentValues, option.label]);
                        } else {
                          field.onChange(
                            currentValues.filter((id) => id !== option.label)
                          );
                        }
                      }}
                      className="data-[state=checked]:border-primary-blue data-[state=checked]:bg-primary-blue flex size-5 items-center justify-center rounded-[6px] border-gray-300 bg-white text-white"
                    />
                    <label className="min-w-0 break-words text-sm font-bold text-gray-500">
                      {option.label}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
          {fieldState.error && (
            <FormMessage>{fieldState.error.message}</FormMessage>
          )}
        </FormItem>
      )}
    />
  );
}